module.exports = __webpack_public_path__ + "img/1511426857.bfdfa1c1.jpg";